import classNames from 'classnames';
import UnconnectedMap, {Props} from './UnconnectedMap';
import {ViewerEvent} from '../events';
import {ViewerProps} from './props';

/**
 * Názvy synchronizovaných properties specifických pro mapový zobrazovač.
 *
 * @ignore
 */
const syncedPropNames = ['tools', 'contextTools'];

/**
 * Mapový zobrazovač nenapojený na store.
 *
 * @ignore
 */
export default class UnconnectedMapViewer extends UnconnectedMap<ViewerProps, ViewerEvent> {
    /**
     * Vrátí jména properties, které synchronizujeme s mapovým serverem při inicializaci.
     *
     * @returns Jména properties.
     */
    protected getInitialSyncedPropNames(): string[] {
        return [...super.getInitialSyncedPropNames(), ...syncedPropNames];
    }

    /**
     * Vrátí jména properties, které synchronizujeme s mapovým serverem při změně.
     *
     * @returns Jména properties.
     */
    protected getSyncedPropNames(): string[] {
        return [...super.getSyncedPropNames(), ...syncedPropNames];
    }

    /**
     * Vrátí cestu mapové stránky v URL.
     *
     * @returns Cesta.
     */
    protected getPath(): string {
        if (this.props.nativeMobile) {
            return 'embed-native-mobile-map';
        } else if (this.props.clientMode != null) {
            return this.props.clientMode;
        } else {
            return 'embed-map';
        }
    }

    /**
     * Voláno po aktualizaci komponenty.
     *
     * @param prevProps - Předchozí properties.
     */
    componentDidUpdate(prevProps: ViewerProps & Props<ViewerEvent>): void {
        if (prevProps.nativeMobile !== this.props.nativeMobile) {
            this.updateSrc(); // Dojde ke změně path, nutno přegenerovat URL.
        }
        super.componentDidUpdate(prevProps);
    }

    /**
     * Vykreslí komponentu.
     *
     * @returns Element.
     */
    render(): JSX.Element | null {
        const {className: customClassName, tools, contextTools, nativeMobile, clientMode, topicChangeEnabled, ...otherProps} = this.props;

        const className = classNames(
            'map-viewer',
            'mapio-feature-editor', // Pro zpětnou kompatibilitu.
            customClassName,
        );

        return this.renderFrame({className, ...otherProps});
    }
}
